import Section from '@latitude/section';

export default Section;
